import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import SoftButton from 'components/SoftButton';
import ResolutionNoteField from '../../policyCancellation/components/ResolutionNoteField';

const path = 'POLICY_DETAILS.CANCELLATION_MANAGEMENT.CONFIRM_DISMISS';

const DismissRequestDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [note, setNote] = useState('');

  useEffect(() => {
    if (open) {
      setNote('');
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{t(`${path}.title`)}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{t(`${path}.message`)}</Typography>
        <ResolutionNoteField
          value={note}
          onChange={setNote}
          label={t(`${path}.noteLabel`)}
          required
        />
      </DialogContent>
      <DialogActions>
        <SoftButton
          size="small"
          variant="outlined"
          color="secondary"
          onClick={onClose}
        >
          {t('COMMON.cancel')}
        </SoftButton>
        <SoftButton
          size="small"
          variant="contained"
          color="secondary"
          disabled={!note.trim()}
          onClick={() => onConfirm(note.trim())}
        >
          {t(`${path}.confirm`)}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

DismissRequestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DismissRequestDialog;
